import {push} from 'connected-react-router';
import UserService from './service/UserService';
import TrimbleId from '../../components/Auth/TrimbleId';
import {VEHICLE_ONDEMAND_KEY} from '../configuration/localstorageKeys';
import SwitchCustomerService from '../../SwitchCustomer/service/SwitchCustomerService';
import translation, {availableLanguages, defaultLanguage} from '../translation';
import {
  LOADED,
  LOADING,
  LOGIN,
  LOGOUT,
  SET_LANGUAGE_REQUEST,
  SET_LANGUAGE_SUCCESS,
  SET_LANGUAGE_FAIL
} from './UserActionsType';

const doLogout = async dispatcher => {
  if (TRIMBLE_ID_FEATURE_TOGGLE) {    
    TrimbleId.logout();
  } else {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('language');
    localStorage.removeItem(VEHICLE_ONDEMAND_KEY);
    dispatcher({type: LOGOUT});
    dispatcher(push('/'));
  }
};

export const logout = () => dispatcher => doLogout(dispatcher);

export const loadUserInformation = () => async dispatcher => {
  dispatcher({type: LOADING});
  try {
    const userInformation = await UserService.get();
    const userLanguage = await UserService.getLanguage(userInformation.userId);
    /**
     * TTL system - Gobal Admin user will not have any customerId assoicated to the user profile. So as part of 
     * PNVI-8791, we will get the customers list and pick the first customer and assign as default customer id as an hack to avoid
     * subsequent api calls failing due to customerId parameter.
     */
    if(userInformation.systemId &&  userInformation.systemId === 'ttl' && !userInformation.customerId && (userInformation.changeCustomer === true || userInformation.changeCustomer === "true")){
      const customerId = localStorage.getItem("ttl_customerId");
      if(customerId){
        userInformation.customerId = customerId;
      } else {
        const customers = await SwitchCustomerService.loadCustomers();
        if(customers && customers.length > 0 && customers[0] && customers[0].id){
          userInformation.customerId = customers[0].id;
        }
      }
    }
    // set language
    if (userLanguage) {
      localStorage.setItem('language', userLanguage);
      translation(userLanguage);
    } else {
      let languageToUse = (navigator.language || navigator.userLanguage).toLowerCase();
      if (availableLanguages.indexOf(languageToUse) === -1) {
        languageToUse = defaultLanguage;
      }
      localStorage.setItem('language', languageToUse);
      translation(languageToUse);
    }
    return dispatcher({type: LOADED, payload: {...userInformation, language: userLanguage}});
  } catch (e) {
    console.error('Unable to get user information', e);
    return doLogout(dispatcher);
  }
};

export const setUserLanguage = (userId, langId) => async dispatcher => {
  dispatcher({type: SET_LANGUAGE_REQUEST});
  try {
    await UserService.setLanguage(userId, langId);
    localStorage.setItem('language', langId);
    translation(langId);
    return dispatcher({type: SET_LANGUAGE_SUCCESS});
  } catch (e) {
    console.error('Unable to save Language', e);
    return dispatcher({type: SET_LANGUAGE_FAIL});
  }
};

export const login = data => async dispatcher => {
  localStorage.setItem('auth', JSON.stringify(data));
  dispatcher({type: LOGIN, payload: data});
};
